export default {
  "operationRecord.thead.index": "#NO",
  "operationRecord.thead.operator": "Operator",
  "operationRecord.thead.sourceType": "SourceType",
  "operationRecord.thead.sourceId": "SourceId",
  "operationRecord.thead.actionType": "ActionType",
  "operationRecord.thead.before": "Edit Before",
  "operationRecord.thead.after": "Edit After",
  "operationRecord.thead.actionTime": "ActionTime",
  "operationRecord.thead.actionTimeFrom": "ActionTimeFrom",
  "operationRecord.thead.actionTimeTo": "ActionTimeTo",
  "operationRecord.tooltip.copy": "Copy Userno",
  "operationRecord.tooltip.showUserDetails": "ShowUserDetails",
};
